/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Injectable} from '@angular/core';
import { HttpClient } from "@angular/common/http";
import {EnvironmentService} from "@irian-ro/util-environment";
import {
  InvoiceDateChangeRequestDtoModel, InvoiceDateChangeRequestVoModel
} from "@well/domain";
import { AbstractResourceService, JsonApiListResourceMetadataBase, JsonApiResource, QueryParams } from '@irian-ro/abstract-resource';
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class InvoiceDateChangeResourceService extends AbstractResourceService<InvoiceDateChangeRequestVoModel, InvoiceDateChangeRequestDtoModel, any, any> {

  constructor(httpClient: HttpClient, environmentService: EnvironmentService) {
    super(
      httpClient,
      environmentService.getEnvironmentProperty('invoiceDateChangeRequestUrl'),
      InvoiceDateChangeRequestVoModel,
      InvoiceDateChangeRequestDtoModel
    )
  }

  findAllForInvoiceUuid(invoiceUuid: any, query?: any, additionalParams?: any): Observable<JsonApiResource<InvoiceDateChangeRequestVoModel[], JsonApiListResourceMetadataBase>> {
    const queryString = new QueryParams(
      query,
      additionalParams ? additionalParams : []
    ).toString();
    return this.httpClient?.get(`${this.url}/${invoiceUuid}${queryString}`, {headers: this.headers}).pipe(this.mapToListOfObjects());
  }
}
